export const colors = [
    '#0074D9',
    '#813772',
    'B82604',
    '#3500d3', 
    '#FF4136', 
    '#39CCCC', 
    '#fccd04', 
    '#3D9970', 
    '#85144b', 
    '#FF851B', 
    '#3D9970', 
    '#FF4136', 
    '#00ff00', 
    '#666600', 
    '#990033', 
    '#ff3333', 
    '#ffcc00', 
    '#6600ff', 
    '#910000', 
    '#3366ff'
];
